var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 36",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Uzbekistan flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 36,
    fill: "#1eb6e8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 54,
    height: 12,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 54,
    height: 12,
    fill: "#1faa59"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 54,
    height: 1,
    fill: "#ce1126"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 54,
    height: 1,
    fill: "#ce1126"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 5,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 8,
    r: 4.2,
    fill: "#1eb6e8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 10.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 10.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 10.5,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.366693e104ec26220cd1791bd549454f.svg";
export { ForwardRef as ReactComponent };